import React, { Component, useState } from "react";
import { CircularProgressbar } from "react-circular-progressbar";
import { setShowProfile, setProfileSection, setProfileDropdown } from "../../../../actions/actionDashboard";
import "react-circular-progressbar/dist/styles.css";
import {
  Card,
  Button,
  CardBody,
  Row,
  Modal,
  ModalBody,
  Col,
  Spinner,
  UncontrolledTooltip,
} from "reactstrap";
import { connect } from "react-redux";
import RemainingTime from "./RemainingTime";
import Proptypes from "prop-types";
import Select from "react-select";
import "react-select/dist/react-select.css";
import moment from "moment";
import { withRouter } from "react-router";
import { Link } from "react-router-dom";
import ReactHtmlParser from "react-html-parser";
import {
  destroyKasms,
  getUserKasms,
  createKasms,
  getStatusKasms,
  updateKeepalive,
  getUserImages,
  getViewedKasms,
  getDockedSessions,
  setDockedSessions,
} from "../../../../actions/actionDashboard";
import Image from "./image";
import { logout } from "../../../../actions/actionLogin";
import _ from "lodash";
import { NotificationManager } from "react-notifications";
import LoadingSpinner from "../../../../components/LoadingSpinner/index";
import { getUserUsageSummary } from "../../../../actions/actionUser";
import livekasmbg from "../../../../../assets/images/livekasmbg.png";
import cross from "../../../../../assets/images/cross.png";
import rightArrow from "../../../../../assets/images/right-arrow.svg";
import playLight from "../../../../../assets/images/play-light.svg";
import trashLight from "../../../../../assets/images/trash-light.svg";
var intervalID;

function KasmIcon({ kasm }) {
  const image = _.get(kasm, 'image.image_src', 'img/favicon.png') || 'img/favicon.png'
  const name = _.get(kasm, 'image.friendly_name', '')
  return (
    <img
      onError={(e) => e.target.src = "img/favicon.png"}
      className="active-session-icon"
      src={image}
      alt={name} />
  )
}

function SingleKasm({ kasm, screenShot, moveToDock, moveToDockMoving, onHandleResumeKasm, onDeleteConfirm, onMinimizeSession }) {
  return (
    <div id={'kasm' + kasm.kasm_id} style={{
      position: (moveToDock !== null && moveToDock.kasm_id === kasm.kasm_id) ? 'fixed' : 'relative',
      left: (moveToDock !== null && moveToDock.kasm_id === kasm.kasm_id) ? moveToDock.left + 'px' : '0',
      top: (moveToDock !== null && moveToDock.kasm_id === kasm.kasm_id) ? moveToDock.top + 'px' : '0',
      transform: (moveToDockMoving !== false && moveToDock !== null && moveToDock.kasm_id === kasm.kasm_id) ? 'translate(' + moveToDock.tx + 'px,' + moveToDock.ty + 'px) scale(10%)' : '',
    }} className={(moveToDock !== null && moveToDock.kasm_id === kasm.kasm_id && moveToDockMoving ? 'moving ' : '') + (moveToDock !== null && moveToDock.kasm_id === kasm.kasm_id ? 'moveToDock ' : '') + 'live-kasm-single'}>
      <button className="minimize tw-bg-transparent hover:tw-bg-yellow-500 hover:tw-border-yellow-700 tw-group" onClick={() => onMinimizeSession(kasm.kasm_id)}>
        <div className="minimizebutton group-hover:tw-text-black"><span><strong>&ndash;</strong></span></div>
      </button>
      <div className="live-kasm-single-title tw-flex tw-items-center">
        <div className="icon-container"><KasmIcon kasm={kasm} /></div>
        <div className="tw-flex tw-flex-col single-details">
          <div className="single-title">{kasm.image.friendly_name}</div>
          <div className="single-subline">Uptime <UpTime className="tw-inline tw-mr-4" start_date={kasm.start_date} /> Expires <RemainingTime className="tw-inline" current_time={moment.utc()} expiration_date={kasm.expiration_date} /></div>
        </div>
      </div>
      <div className="live-kasm-single-preview tw-flex tw-justify-center tw-items-center">
        <span className="tw-flex tw-z-10 tw-absolute tw-h-3 tw-w-3 tw-bottom-3 tw-right-3">
          <span className="tw-absolute tw-inline-flex tw-animate-pulse tw-h-full tw-w-full tw-rounded-full tw-bg-green-500 tw-opacity-75"></span>
        </span>
        <Image
          className="livekasmimg"
          src={screenShot ? screenShot : livekasmbg}
          alt="livekasmbg"
        />
      </div>
      <div className="live-kasm-single-buttons">
        <button
          className="text resume tw-group"
          onClick={() => onHandleResumeKasm(kasm.kasm_id)}
        >
          <span className="button-icon tw-bg-white/30 group-hover:tw-bg-white/60 dark:tw-bg-slate-900 group-hover:tw-bg-blue-500">
            <svg className="tw-w-full group-hover:tw-fill-white" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 384 512"><path d="M24.52 38.13C39.66 29.64 58.21 29.99 73.03 39.04L361 215C375.3 223.8 384 239.3 384 256C384 272.7 375.3 288.2 361 296.1L73.03 472.1C58.21 482 39.66 482.4 24.52 473.9C9.377 465.4 0 449.4 0 432V80C0 62.64 9.377 46.63 24.52 38.13V38.13zM56.34 66.35C51.4 63.33 45.22 63.21 40.17 66.04C35.13 68.88 32 74.21 32 80V432C32 437.8 35.13 443.1 40.17 445.1C45.22 448.8 51.41 448.7 56.34 445.7L344.3 269.7C349.1 266.7 352 261.6 352 256C352 250.4 349.1 245.3 344.3 242.3L56.34 66.35z" /></svg>
          </span>
          Resume
        </button>
        <button
          className="text delete tw-group"
          onClick={(event) =>
            onDeleteConfirm(event, kasm)
          }
        >
          <span className="button-icon tw-bg-white/30 group-hover:tw-bg-white/60 dark:tw-bg-slate-900 group-hover:tw-bg-red-500 dark:tw-fill-white/80">
            <svg className="tw-w-full group-hover:tw-fill-white" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 448 512"><path d="M432 64C440.8 64 448 71.16 448 80C448 88.84 440.8 96 432 96H413.7L388.2 452.6C385.9 486.1 357.1 512 324.4 512H123.6C90.01 512 62.15 486.1 59.75 452.6L34.29 96H16C7.164 96 0 88.84 0 80C0 71.16 7.164 64 16 64H111.1L137 22.56C145.8 8.526 161.2 0 177.7 0H270.3C286.8 0 302.2 8.526 310.1 22.56L336.9 64H432zM177.7 32C172.2 32 167.1 34.84 164.2 39.52L148.9 64H299.1L283.8 39.52C280.9 34.84 275.8 32 270.3 32H177.7zM381.6 96H66.37L91.67 450.3C92.87 467 106.8 480 123.6 480H324.4C341.2 480 355.1 467 356.3 450.3L381.6 96z" /></svg>
          </span>
          Delete
        </button>

      </div>
    </div>
  );

}


function UsageCounter({ props, state }) {

  const { usageSummary } = props;
  const [showinfo, setShowinfo] = useState(false);
  let interval = "";
  let intervalTranslation = {
    total: "",
    monthly: "This Month",
    weekly: "This Week",
    daily: "Today",
  };

  if (usageSummary && usageSummary.usage_limit_remaining) {
    let percent = 0;
    if (usageSummary.usage_limit_remaining > 0) {
      percent =
        100 -
        (usageSummary.usage_limit_remaining /
          usageSummary.usage_limit_hours) *
        100;
    } else {
      percent = 100;
    }

    let color = "info";

    if (percent > 70) {
      color = "warning";
    } 
    if (percent > 90) {
      color = "danger";
    } 
  }

  if (usageSummary) {
    interval = intervalTranslation[usageSummary.usage_limit_interval];
    if (usageSummary.usage_limit_type === "per_group") {
      interval += ". Usage is shared with other group members.";
    }
  }

  const limitHours = (usageSummary && usageSummary.usage_limit_hours) || 0;
  const remainingHours =
    (usageSummary &&
      usageSummary.usage_limit_remaining &&
      usageSummary.usage_limit_remaining < 0
      ? 0
      : usageSummary &&
      usageSummary.usage_limit_remaining &&
      usageSummary.usage_limit_remaining.toFixed(1)) || 0;

  let percentage = ((limitHours - remainingHours) / limitHours) * 100;

  if (remainingHours === 0) percentage = 100;

  const isRed = percentage > 75 ? true : false;
  const isYellow = percentage > 50 && percentage <= 75 ? true : false;
  const isGreen = percentage > 0 && percentage <= 50 ? true : false;



  return (
    <div className="session-container">
      {usageSummary && usageSummary.usage_limit ? (
        <React.Fragment>
          <div
            className={`session-single usage ${isRed
              ? "red-stroke"
              : isYellow
                ? "yellow-stroke"
                : isGreen
                  ? "green-stroke"
                  : ""
              }`}
            onClick={() => setShowinfo(!showinfo)}
          >
            <CircularProgressbar
              value={percentage && percentage.toFixed()}
              text={`${percentage && percentage.toFixed()
                }%`}
            />
          </div>
          <Card className={'mb-4 session-details ' + (showinfo === true ? 'show' : 'hide')}>
            <div className="session-header"><h4>Usage details - {interval}</h4></div>
            <CardBody>
              <div
                className={`display ${isRed
                  ? "red-stroke"
                  : isYellow
                    ? "yellow-stroke"
                    : isGreen
                      ? "green-stroke"
                      : ""
                  }`}
              >

                <CircularProgressbar
                  value={percentage && percentage.toFixed()}
                  text={`${percentage && percentage.toFixed()
                    }%`}
                />
              </div>
              <div style={{ marginTop: '30px' }} className="time-wrapper">
                <div className="item">
                  <div className="uptime">Allowance</div>
                  <div className="text-value">{usageSummary.usage_limit_hours} hours</div>
                </div>
                <div className="item">
                  <div className="uptime">Used</div>
                  <div className="text-value">{(usageSummary.usage_limit_hours - usageSummary.usage_limit_remaining).toFixed(1)} hours</div>
                </div>
              </div>

              <div style={{ marginTop: '30px' }} className="standalone-div text-center">
                <button onClick={() => {
                  props.setProfileSection('sessionusage');
                  props.setProfileDropdown(true);
                  props.setShowProfile(true);
                }} className="tw-mx-auto tw-rounded tw-h-10 tw-bg-blue-500 hover:tw-bg-slate-600 tw-text-white tw-flex tw-items-center tw-transition">
                  <span className="tw-w-44">More details on usage</span>

                </button>

              </div>
            </CardBody>
          </Card>
        </React.Fragment>
      ) : (
        ""
      )}
    </div>
  )

}


function UpTime(props) {
  let current = moment.utc(props.current_time)
  let start = moment.utc(props.start_date)

  return (
    <div className={props.className}>
      {current
        .diff(start, 'days')
        ? current.diff(start, 'days') + 'd '
        : ""}
      {current
        .diff(start, 'hours')
        ? moment.utc(current.diff(start, 'hh:mm:ss')).format("HH[h] ")
        : ""}
      {moment.utc(current.diff(start, 'hh:mm:ss')).format("mm[m]")}
    </div>
  )
}

class Listkasms extends Component {
  constructor(props) {
    super(props);
    this.containerRef = React.createRef();
    this.state = {
      isSessionScreenshotLoaded: false,
      modal: false,
      deleteConfirm: null,
      videoQuality: window.localStorage.getItem("kasm_video_quality") ? JSON.parse(window.localStorage.getItem("kasm_video_quality")) : 1,
      kasmId: "",
      deleteKasmName: "",
      deleteKasmImage: "",
      currentId: null,
      url: "",
      activeCard: false,
      loader: false,
      attempt: 0,
      progressBarValues: [],
      pointPresenceValues: [],
      persistentProfileValues: [],
      zoneSelections: {},
      networkSelections: {},
      refreshing: false,
      showTips: true,
      toggleControlPanel: false,
      createClicked: false,
      createResumeClicked: false,
      disconnect: false,
      deleteClicked: false,
      dropdownOpen: false,
      availableKasms: [],
      isLaunchModal: false,
      zoneDropDown: false,
      appToLaunch: null,
      selectedKasmData: {},
      valueGroups: {},
      isPickerShow: false,
      searchTerm: "",
      showResetConfirmationDialog: false,
      resetConfirmationText: "",
      activeKasmItem: null,
      moveToDock: null,
      moveToDockMoving: false,
      liveKasms: [],
      tiletype: 'rectangular',
      openTabIn: 'current'
    };
    this.deleteConfirm = this.deleteConfirm.bind(this);
    this.destroyKasms = this.destroyKasms.bind(this);
    this.initializePointsofPresence = this.initializePointsofPresence.bind(
      this
    );
    this.initializePersistentProfile = this.initializePersistentProfile.bind(
      this
    );
    this.initializeZones = this.initializeZones.bind(this);
    this.initializeNetworks = this.initializeNetworks.bind(this);
    this.renderLiveKasms = this.renderLiveKasms.bind(this);
    this.renderDockKasms = this.renderDockKasms.bind(this);
    this.renderAvailableKasms = this.renderAvailableKasms.bind(this);
    this.toggle = this.toggle.bind(this);
    this.toggleCard = this.toggleCard.bind(this);
    this.createKasm = this.createKasm.bind(this);
    this.handlePointPresenceDropDown = this.handlePointPresenceDropDown.bind(
      this
    );
    this.handlePersistentProfileDropDown = this.handlePersistentProfileDropDown.bind(
      this
    );
    this.handleResumeKasm = this.handleResumeKasm.bind(this);
    this.stateFunctionUrl = this.stateFunctionUrl.bind(this);
    this.toggleDrop = this.toggleDrop.bind(this);
    this.updateProgressBarValue = this.updateProgressBarValue.bind(this);
    this.handleDisconnect = this.handleDisconnect.bind(this);
    this.defaultThumb = this.defaultThumb.bind(this);
    this.renderJoinedKasms = this.renderJoinedKasms.bind(this);
    this.toggleDropDown = this.toggleDropDown.bind(this);
    this.launchModal = this.launchModal.bind(this);
    this.toggleLaunchModal = this.toggleLaunchModal.bind(this);
    this.toggleZone = this.toggleZone.bind(this);
    this.handleChange = this.handleChange.bind(this);
    this.togglePicker = this.togglePicker.bind(this);
    this.verifyResetConfirmation = this.verifyResetConfirmation.bind(this);
    this.openLink = this.openLink.bind(this);
    this.showKasmInfo = this.showKasmInfo.bind(this);
    this.minimizeSession = this.minimizeSession.bind(this);
    this.menuBarRef = React.createRef(null);
  }


  openLink(url) {
    console.log("Opening URL " + url)
    if (this.state.openTabIn === 'new' || this.state.openTabIn === 'window') {
      const inWindow = (this.state.openTabIn === 'window') ? 'resizable=yes,top=0,left=0,width=800,height=640' : null
      window.open(url, '_blank', inWindow)
    } else {
      window.location.href = url;
    }
  }

  async minimizeSession(kasm_id) {
    const start = document.getElementById('kasm' + kasm_id); // Active session that minimise was clicked on
    const startposition = start.getBoundingClientRect()

    const node = this.containerRef.current; // Docked session container
    const rect = node.getBoundingClientRect();

    this.setState({
      moveToDock: {
        kasm_id: kasm_id,
        left: startposition.x - 20,
        top: startposition.y - 100
      }
    })

    await new Promise(resolve => setTimeout(resolve, 50)); // A small pause is needed overwise the move doesn't trigger
    this.setState({
      moveToDockMoving: true, moveToDock: {
        ...this.state.moveToDock,
        kasm_id: kasm_id,
        tx: rect.x - this.state.moveToDock.left - 125,
        ty: rect.y - this.state.moveToDock.top - 180
      }
    })

    await new Promise(resolve => setTimeout(resolve, 300)); // The animation moving to the dock takes 300ms so wait for it to finish before updating the docked list
    const kasm = this.props.liveKasms.find(o => o.kasm_id === kasm_id)
    const dockedSessions = [
      ...this.props.dockedSessions,
      kasm
    ];

    await this.props.setDockedSessions(dockedSessions)
    this.setState({ moveToDockMoving: false, moveToDock: null });
  }
  async maximiseSession(kasm_id) {
    let arr = [...this.props.dockedSessions];
    const indexOfObject = arr.findIndex(o => {
      return o.kasm_id === kasm_id;
    });
    arr.splice(indexOfObject, 1);

    await this.props.setDockedSessions(arr)
  }

  togglePicker() {
    this.setState(({ isPickerShow }) => ({
      isPickerShow: !isPickerShow,
    }));

    if (!this.state.isPickerShow) {
      document.body.style.overflow = 'hidden';
    } else {
      document.body.style.overflow = 'unset';
    }
  }

  defaultThumb(e) {
    e.target.src = "img/favicon.png";
  }
  toggleZone() {
    this.setState({
      zoneDropDown: !this.state.zoneDropDown,
    });
  }

  launchModal(selectedData) {
    this.setState({
      isLaunchModal: !this.state.isLaunchModal,
      selectedKasmData: selectedData,
    });
  }
  toggleLaunchModal(event) {
    this.setState({
      isLaunchModal: !this.state.isLaunchModal,
    });
  }

  // Update the value in response to user picking event
  handleChange(name, value) {
    this.setState(({ valueGroups }) => ({
      valueGroups: {
        ...valueGroups,
        [name]: value,
      },
    }));
  }

  stateFunctionUrl() {
    this.setState({ url: "" });
  }

  deleteConfirm(event, kasm) {
    event.stopPropagation();
    this.setState({ modal: !this.state.modal, kasmId: kasm.kasm_id, deleteKasmName: kasm.image.friendly_name, deleteKasmImage: kasm.image.image_src });
  }

  handleDisconnect() {
    this.stateFunctionUrl();
    this.setState({
      attempt: 0,
      showTips: false,
      disconnect: true,
    });
    this.delay_check_load();
  }

  toggleDropDown() {
    this.setState({
      dropdownOpen: !this.state.dropdownOpen,
    });
  }

  handleResumeKasm(kasm_id) {
    this.setState({ kasmId: kasm_id, createResumeClicked: true });

    this.props
      .getStatusKasms(kasm_id)
      .then(() => this.props.history.push("/kasm/" + kasm_id))
      .catch(
        () => this.setState({ kasmId: kasm_id, createResumeClicked: false }),
        "Unable to Fetch API Data"
      );
  }

  destroyKasms() {
    this.setState({
      deleteClicked: true,
    });

    this.props
      .destroyKasms(this.state.kasmId)
      .then(() => this.handleDeleteSuccess())
      .catch(() => this.handleDeleteError());
  }

  toggle() {
    this.setState({ modal: !this.state.modal });
  }

  handlePointPresenceDropDown(imageId, value) {
    let pointPresenceValues = this.state.pointPresenceValues;
    pointPresenceValues.map((image) => {
      if (image.imageId === imageId) {
        image.value = value;
      }
    });
    this.setState({ pointPresenceValues });
  }

  handlePersistentProfileDropDown(imageId, value) {
    let persistentProfileValues = this.state.persistentProfileValues;
    persistentProfileValues.map((image) => {
      if (image.imageId === imageId) {
        image.value = value;
      }
    });
    this.setState({ persistentProfileValues });
  }

  handleZoneDropDown(imageId, value) {
    let zoneSelections = this.state.zoneSelections;

    zoneSelections[imageId] = value;
    this.setState({ zoneSelections: zoneSelections });
  }

  handleNetworksDropDown(imageId, value) {
    let networkSelections = this.state.networkSelections;

    networkSelections[imageId] = value;
    this.setState({ networkSelections: networkSelections });
  }

  toggleCard() {
    this.state({ card3: !this.state.card3 });
  }

  handleDeleteSuccess() {
    const { destroyKasmsErrorMessage } = this.props;
    if (destroyKasmsErrorMessage) {
      NotificationManager.error(destroyKasmsErrorMessage, "Delete Session", 3000);
    } else {
      const userInfo = JSON.parse(window.localStorage.user_info);
      this.setState({ modal: false, deleteClicked: false });
      this.props.getUserKasms({ getuserkasmsLoading: false });
      this.props.getUserUsageSummary();
      NotificationManager.success(
        "Successfully Deleted Kasm",
        "Delete Kasm",
        3000
      );
    }
  }

  verifyResetConfirmation(text) {
    if (text === "reset") {
      this.setState({
        resetConfirmationText: text,
        showResetConfirmationDialog: false
      }, () =>
        this.createKasm(this.state.selectedKasmData.image_id, this.state.selectedKasmData.available)
      );
    }
  }

  createKasm(imageId, available) {
    if (!available) {
      NotificationManager.error(
        "This image is not currently available. Agent may still be downloading Image.",
        "Image Loading",
        3000
      );
      return;
    }

    // make sure the user confirmed resetting a persistent profile
    const persistentProfileSettings = this.state.persistentProfileValues.find(profile =>
      profile.imageId === imageId
    );

    if (persistentProfileSettings.value.value === "Reset" && this.state.resetConfirmationText !== "reset") {
      this.setState({ showResetConfirmationDialog: true });
      return;
    }

    this.setState({ currentId: imageId, createClicked: true, resetConfirmationText: "" });
    let currentImage = this.state.pointPresenceValues.find(
      (image) => image.imageId === imageId
    );
    let currentImage2 = this.state.persistentProfileValues.find(
      (image) => image.imageId === imageId
    );
    let selectedZone = this.state.zoneSelections[imageId];
    let selectedNetwork = this.state.networkSelections[imageId];
    let persistent_profile_mode =
      currentImage2 && currentImage2.value ? currentImage2.value.value : "";
    window.localStorage.setItem(
      "persistent_profile_mode",
      persistent_profile_mode
    );
    this.props
      .createKasms({
        point_of_presence:
          currentImage && currentImage.value ? currentImage.value.value : "",
        persistent_profile_mode: persistent_profile_mode,
        image_id: imageId,
        x_res: window.innerWidth,
        y_res: window.innerHeight,
        zone_id: selectedZone && selectedZone.value ? selectedZone.value : "",
        network_id: selectedNetwork && selectedNetwork.value ? selectedNetwork.value : "",
      })
      .then(() => {
        this.handleCreateSuccess();
      })
      .catch(() => this.handleCreateError());
  }

  handleDeleteError() {
    const { deleteKasmsError } = this.props;
    this.setState({ createClicked: false, deleteClicked: false });
    if (deleteKasmsError) {
      NotificationManager.error(deleteKasmsError, "Delete Session", 3000);
    } else {
      NotificationManager.error("Failed to Delete Session", "Delete Session", 3000);
    }
  }

  handleCreateError() {
    const { createKasmsError, errorCreateMessageDetail } = this.props;
    this.setState({ createClicked: false });
    if (createKasmsError) {
      NotificationManager.error(createKasmsError, "Create Session", 3000);
      if (errorCreateMessageDetail) {
        console.error(errorCreateMessageDetail);
      }
    } else {
      NotificationManager.error("Gateway Time-out", "Create Session", 3000);
    }
  }

  handleCreateSuccess() {
    const { errorCreateMessage, errorCreateMessageDetail } = this.props;
    this.setState({ createClicked: false });
    if (errorCreateMessage) {
      NotificationManager.error(errorCreateMessage, "Create Kasm", 3000);
      if (errorCreateMessageDetail) {
        console.error(errorCreateMessageDetail);
      }
    } else {
      NotificationManager.success("Kasm Created", "Successfully Created Kasm");
      const { createdKasms, getStatusKasms } = this.props;
      if (createdKasms.kasm_id) {
        if (this.state.openTabIn === 'new' || this.state.openTabIn === 'window') {
          const inWindow = (this.state.openTabIn === 'window') ? 'resizable=yes,top=0,left=0,width=800,height=640' : null
          window.open("/#/kasm/" + createdKasms.kasm_id, '_blank', inWindow)
          this.toggleLaunchModal()
          this.props.getUserKasms({ getuserkasmsLoading: false })
          setTimeout(function () { this.props.getUserKasms({ getuserkasmsLoading: false }) }.bind(this), 10000) // update after 10 seconds to give screenshot time to generate
        } else {
          this.props.history.push("/kasm/" + createdKasms.kasm_id);
        }
      }
    }
  }

  toggleDrop(index) {
    index === this.state.activeCard
      ? this.setState({ activeCard: null })
      : this.setState({ activeCard: index });
  }

  updateProgressBarValue() {
    let dataCopy = [];
    const self = this;
    this.props.liveKasms &&
      this.props.liveKasms.length > 0 &&
      this.props.liveKasms.map((kasm) => {
        const now = new Date();
        const utc = new Date(now.getTime() + now.getTimezoneOffset() * 60000);
        const start_date = new Date(kasm.start_date);
        const end_date = new Date(kasm.expiration_date);
        let seconds = (end_date - start_date) / 1000;
        dataCopy.push({
          current_time: (utc - start_date) / 1000,
          expiry_time: seconds,
        });
      });

    intervalID = setInterval(function () {
      dataCopy.map((item, index) => {
        dataCopy[index].current_time = item.current_time + 1;
      });
      // FIXME KASM-365. Setting the state causes the full page to be re-rendered
      self.setState({ progressBarValues: dataCopy });
    }, 1000);
  }

  initializePointsofPresence(availableKasms) {
    let pointPresenceValues = [];
    availableKasms.map((kasm) =>
      pointPresenceValues.push({ imageId: kasm.image_id, value: "" })
    );
    this.setState({ pointPresenceValues });
  }

  initializePersistentProfile(availableKasms) {
    let persistentProfileValues = [];

    let cached_persistent_profile_mode = window.localStorage.getItem(
      "persistent_profile_mode"
    );
    if (
      !cached_persistent_profile_mode ||
      (cached_persistent_profile_mode &&
        cached_persistent_profile_mode != "Disabled")
    ) {
      cached_persistent_profile_mode = "Enabled";
    }

    availableKasms.map((kasm) =>
      persistentProfileValues.push({
        imageId: kasm.image_id,
        value: {
          key: cached_persistent_profile_mode,
          value: cached_persistent_profile_mode,
        },
      })
    );
    this.setState({ persistentProfileValues });
  }

  initializeZones(availableKasms) {
    let zoneSelections = {};

    availableKasms.map((kasm) => (zoneSelections[kasm.image_id] = ""));
    this.setState({ zoneSelections: zoneSelections });
  }

  initializeNetworks(availableKasms) {
    let networkSelections = {};

    availableKasms.map((kasm) => (networkSelections[kasm.image_id] = ""));
    this.setState({ networkSelections: networkSelections });
  }

  UNSAFE_componentWillReceiveProps(nextProps) {
    if (this.props.availableKasms) {
      const newArray =
        this.state.availableKasms && this.state.availableKasms.length > 0
          ? this.state.availableKasms
          : this.props.availableKasms;
      this.setState({
        availableKasms: newArray,
      });
    }

    if (
      this.props.availableKasms !== nextProps.availableKasms &&
      nextProps.availableKasms &&
      nextProps.availableKasms.length > 0
    ) {
      this.initializePointsofPresence(nextProps.availableKasms);
      this.initializePersistentProfile(nextProps.availableKasms);
      this.initializeZones(nextProps.availableKasms);
      this.initializeNetworks(nextProps.availableKasms);
    }
  }

  componentWillUnmount() {
    //Stops memory leak from setInterval calls
    if (intervalID) {
      window.clearInterval(intervalID);
    }
  }

  componentDidMount() {
    if (window.localStorage.getItem("joined_kasms")) {
      let viewed_kasms = JSON.parse(window.localStorage.getItem("joined_kasms"))
        .kasms;
      this.props.getViewedKasms(viewed_kasms);
    }
    this.props.availableKasms &&
      this.initializePointsofPresence(this.props.availableKasms);
    this.props.availableKasms &&
      this.initializePersistentProfile(this.props.availableKasms);
    this.props.availableKasms &&
      this.initializeZones(this.props.availableKasms);
    this.props.availableKasms &&
      this.initializeNetworks(this.props.availableKasms);
    this.updateProgressBarValue(this.props.liveKasms);
    this.props.getUserUsageSummary();

    this.props.getDockedSessions()

    if (window.localStorage.getItem("openTabIn")) {
      this.setState({
        openTabIn: window.localStorage.getItem("openTabIn")
      })
    }


    this.setState({
      availableKasms: this.props.availableKasms,
    });
  }
  componentDidUpdate(prevProps, prevState) {
    if (prevProps.availableKasms !== this.props.availableKasms) {
      this.setState({ availableKasms: this.props.availableKasms })
    }

  }

  showKasmInfo(index) {
    if (this.state.activeKasmItem === index) {
      index = null
    }
    this.setState({ activeKasmItem: index })
  }


  renderDockKasms() {
    if (this.state.loader) {
      return (
        <div>
          <div
            className={
              this.props.statusKasms &&
                this.props.statusKasms.is_persistent_profile
                ? "loaderStatus"
                : ""
            }
          >
            Loading Persistent Profile. This may take a moment...
          </div>
          <div className="loaderBg">
            {" "}
            <LoadingSpinner />
          </div>
        </div>
      );
    }
    const { dockedSessions } = this.props;
    const currentTime = moment.utc()
    const liveKasms = dockedSessions.filter(x => moment.utc(x.expiration_date) > currentTime);
    return (
      <React.Fragment>
        {liveKasms && liveKasms.length > 0 ? (
          <React.Fragment>

            {liveKasms
              .map((kasm, index) => {

                return (
                  <div className="session-container" key={index}>
                    <div className="session-single" onClick={() => this.maximiseSession(kasm.kasm_id)}>
                      <div className="icon-container"><KasmIcon kasm={kasm} /></div>
                      <RemainingTime className="time-remaining" current_time={moment.utc()} expiration_date={kasm.expiration_date} />

                    </div>
                  </div>
                );
              })}
          </React.Fragment>
        ) : null}

      </React.Fragment>
    );
  }

  renderLiveKasms() {
    if (this.state.loader) {
      return (
        <div>
          <div
            className={
              this.props.statusKasms &&
                this.props.statusKasms.is_persistent_profile
                ? "loaderStatus"
                : ""
            }
          >
            Loading Persistent Profile. This may take a moment...
          </div>
          <div className="loaderBg">
            {" "}
            <LoadingSpinner />
          </div>
        </div>
      );
    }
    const { liveKasms } = this.props;

    let filteredKasms = []
    if (liveKasms && liveKasms.length > 0){
        filteredKasms = liveKasms.filter((i)=> i.operational_status==='running')
    }

    const currentTime = moment.utc()
    const undockedKasms = filteredKasms.filter(x => !this.props.dockedSessions.some(d => d.kasm_id === x.kasm_id)).filter(x => moment.utc(x.expiration_date) > currentTime);


    let doRefresh = false;

    // We want to refresh the Live Kasms data every so often if there is a delete_pending Kams. it should get cleaned up shortly after.
    if (filteredKasms && filteredKasms.length > 0) {
      for (let i in filteredKasms) {
        if (filteredKasms[i].operational_status === "delete_pending") {
          doRefresh = true;
        }
      }
    }
    if (doRefresh && !this.state.refreshing) {
      this.state.refreshing = true;
      setTimeout(() => {
        const userInfo = JSON.parse(window.localStorage.user_info);
        this.props.getUserKasms({ getuserkasmsLoading: false });
        this.props.getDockedSessions();
        this.state.refreshing = false;
      }, 10000);
    }
    if (undockedKasms && undockedKasms.length <= 0) {
      return null
    }
    return (
      <div className="live-kasms">
        {undockedKasms && undockedKasms.length > 0 ? (
          <React.Fragment>

            {undockedKasms
              .sort(function (a, b) {
                return a.kasm_id.localeCompare(b.kasm_id);
              })
              .map((kasm, index) => {
                const screenShot = kasm.kasm_id
                  ? `${__CLOUD_SERVER__}get_kasm_screenshot?kasm_id=${kasm.kasm_id}&width=1000&height=1000`
                  : livekasmbg;

                return (
                  <SingleKasm
                    kasm={kasm}
                    screenShot={screenShot}
                    moveToDock={this.state.moveToDock}
                    moveToDockMoving={this.state.moveToDockMoving}
                    onHandleResumeKasm={this.handleResumeKasm}
                    onDeleteConfirm={this.deleteConfirm}
                    onMinimizeSession={this.minimizeSession}
                    key={kasm.kasm_id} />
                )
              })}
          </React.Fragment>
        ) : null}
      </div>
    );
  }

  renderAvailableKasms() {
    if (this.state.loader) {
      return (
        <div className="loaderBg">
          {" "}
          <LoadingSpinner />
        </div>
      );
    }
    const { availableKasms } = this.state;
    const { searchText, selectedCategory } = this.props;
    const { persistentProfileValues, pointPresenceValues } = this.state;
    let keysSorted;
    let kasms =
      availableKasms && availableKasms.length > 0 ? [...availableKasms] : [];
    const lowerSearch = searchText.toLowerCase();
    if (searchText !== "") {
      kasms = kasms.filter((i) => {
        const category = i.categories.filter((i) =>
          i.toLowerCase().includes(lowerSearch)
        );
        return (
          i.friendly_name.toLowerCase().includes(lowerSearch) ||
          category.length > 0
        );
      });
    }
    if (selectedCategory !== null && selectedCategory.id !== 'all') {
      kasms = kasms.filter((kasm) => {
        return kasm.categories.includes(selectedCategory.label);
      });
    }
    // filter into 2 groups
    const enabledKasms = kasms.filter(k => k.enabled === true).sort(function (a, b) {
      return a.friendly_name.localeCompare(b.friendly_name);
    })

    const disabledKasms = kasms.filter(k => k.enabled === false).sort(function (a, b) {
      return a.friendly_name.localeCompare(b.friendly_name);
    })

    const groupedKasms = [
      ...enabledKasms,
      ...disabledKasms,
    ]

    return (
      <div className={this.state.isLaunchModal ? 'modalopen' : ''}>
        {availableKasms && availableKasms.length > 0 ? (
          <div className="panelContainerBody panel">
            <div className="tw-max-w-5xl tw-animate-[fadeIn_0.3s_ease-in-out] tw-flex tw-flex-col tw-w-full tw-mx-auto tw-my-auto tw-py-10 tw-pb-20" key={this.props.selectedCategory && this.props.selectedCategory.label}>
              <div className="tw-flex tw-flex-wrap tw-gap-1 tw-justify-center">
                {groupedKasms
                  .map((kasm, index) => {
                    let currentImage =
                      pointPresenceValues && pointPresenceValues.length > 0
                        ? pointPresenceValues.find(
                          (image) => image.imageId === kasm.image_id
                        )
                        : "";
                    let currentImage2 =
                      persistentProfileValues &&
                        persistentProfileValues.length > 0
                        ? persistentProfileValues.find(
                          (image) => image.imageId === kasm.image_id
                        )
                        : null;
                    if (kasm.hidden) {
                      return;
                    } else if (kasm.enabled === true) {
                      return (
                        <div
                          className={this.state.tiletype + ' tile tw-transition-all tw-relative tw-cursor-pointer tw-group tw-flex tw-p-2 tw-items-center tw-justify-center tw-bg-slate-100/90 dark:tw-bg-slate-900/90 tw-shadow tw-rounded hover:tw-shadow-xl hover:tw-bg-gradient-to-r hover:tw-from-dark hover:tw-to-blue-500'}
                          key={kasm.image_id}
                        >
                          <div
                            className="tw-w-full tw-h-full"
                            onClick={() => this.launchModal(kasm)}
                          >
                            {kasm.available || !kasm.enabled ? (
                              ""
                            ) : (
                              <span className="warning-icon tw-z-20">
                                <i
                                  id={"_" + kasm.image_id}
                                  className="fa fa-exclamation-triangle text-danger tw-font-2xl "
                                />
                                <UncontrolledTooltip
                                  target={"_" + kasm.image_id}
                                >
                                  This Image has not been detected on an Agent. It may still be downloading.
                                  Refresh this page to check the status again or contact an Administrator.
                                </UncontrolledTooltip>
                              </span>
                            )}
                            {kasm.image_type === "Link" ? (
                              <div>
                                <span className="warning-icon tw-z-20">
                                  <i
                                    id={"_" + kasm.image_id}
                                    className="fa fa-globe tw-font-2xl"
                                  />
                                  <UncontrolledTooltip
                                    target={"_" + kasm.image_id}
                                  >
                                    This workspace opens an external link outside of the platform.
                                  </UncontrolledTooltip>
                                </span>
                              </div>
                            ): ("") }
                            <div className="show-grid tw-flex tw-h-full tw-items-center">
                              <div
                                className="kasmcard-img tw-flex tw-h-full tw-w-20 tw-mx-4 tw-items-center"
                                xs={5}
                                sm={4}
                                md={3}
                                lg={4}
                                xl={4}
                              >
                                {kasm.image_src && kasm.image_src != "" ? (
                                  <img
                                    onError={this.defaultThumb}
                                    className=" "
                                    src={kasm.image_src}
                                  />
                                ) : (
                                  <div className="img tw-flex tw-justify-center">
                                    <KasmIcon kasm={kasm} />
                                  </div>
                                )}
                              </div>
                              <div
                                className="kasmcard-detail settingPad"
                              >
                                <h5 className="">
                                  {kasm.friendly_name}
                                </h5>
                                <p>{kasm.default_category}</p>
                              </div>
                            </div>
                          </div>
                        </div>
                      );
                    } else {
                      return (
                        <div
                          className={this.state.tiletype + ' tile tw-transition-all disabled tw-cursor-pointer tw-group tw-flex tw-p-2 tw-items-center tw-justify-center tw-bg-slate-100/50 dark:tw-bg-slate-900/30 tw-shadow tw-rounded'}
                          key={index}
                        >
                          <div
                            className="tw-w-full"
                            onClick={() => this.launchModal(kasm)}
                          >
                            {kasm.available || !kasm.enabled ? (
                              ""
                            ) : (
                              <div>
                                <span className="warning-icon">
                                  <i
                                    id={"_" + kasm.image_id}
                                    className="fa fa-exclamation-triangle text-danger tw-font-2xl"
                                  />
                                  <UncontrolledTooltip
                                    target={"_" + kasm.image_id}
                                  >
                                    This Image has not been detected on an Agent. It may still be downloading.
                                    Refresh this page to check the status again or contact an Administrator.
                                  </UncontrolledTooltip>
                                </span>
                              </div>
                            )}
                            <div className="show-grid tw-flex tw-h-full tw-items-center tw-opacity-30">
                              <div
                                className="kasmcard-img tw-flex tw-h-full tw-w-20 tw-mx-4 tw-items-center"
                                xs={5}
                                sm={4}
                                md={3}
                                lg={4}
                                xl={4}
                              >
                                {kasm.image_src && kasm.image_src != "" ? (
                                  <img
                                    onError={this.defaultThumb}
                                    className=" "
                                    src={kasm.image_src}
                                  />
                                ) : (
                                  <KasmIcon kasm={kasm} />
                                )}
                              </div>
                              <div
                                className="kasmcard-detail settingPad"
                              >
                                <h5 className="">
                                  {kasm.friendly_name}
                                </h5>
                                <p>{kasm.default_category}</p>
                              </div>
                            </div>
                          </div>
                        </div>
                      );
                    }
                  })}
              </div>
            </div>
          </div>
        ) : (
          <div className="panelContainerBody"></div>
        )}
      </div>
    );
  }

  renderJoinedKasms() {
    const { viewedKasms, viewKasmsLoading } = this.props;
    if (viewKasmsLoading) {
      return <div>loading...</div>;
    }
    let recent_kasms =
      viewedKasms &&
      viewedKasms.map((kasm, i) => {
        return (
          <Col md="5" xl={3} className="join-shared-kasm" key={i}>
            <Link style={{ color: "black" }} to={"/join/" + kasm.share_id}>
              <Card className={"join-shared-kasm-card"}>
                <Row>
                  <div>
                    {kasm.image_src && kasm.image_src !== "" ? (
                      <img
                        onError={this.defaultThumb}
                        className="thumbnails float-left"
                        src={kasm.image_src}
                      />
                    ) : (
                      <KasmIcon className="thumbnails float-left" kasm={kasm} />
                    )}
                  </div>
                  <div style={{ paddingLeft: "10px" }}>
                    <h5 className="">{kasm.image}</h5>
                    Host: {kasm.user} <br />
                    Share ID: {kasm.share_id}
                  </div>
                </Row>
              </Card>
            </Link>
          </Col>
        );
      });
    return (
      <div className="panelContainer">
        <div className="panelContainerHeading">
          <i className="fa fa-align-justify" />{" "}
          <strong>Recently Viewed Sessions</strong>
        </div>
        <div className="panelContainerBody">
          <Row>{recent_kasms}</Row>
        </div>
      </div>
    );
  }

  render() {
    const { liveKasms } = this.props;
    const {
      selectedKasmData,
      pointPresenceValues,
      persistentProfileValues,
      valueGroups,
      isPickerShow,
    } = this.state;

    let currentImage =
      pointPresenceValues && pointPresenceValues.length > 0
        ? pointPresenceValues.find(
          (image) => image.imageId === selectedKasmData.image_id
        )
        : "";

    let currentImage2 =
      persistentProfileValues && persistentProfileValues.length > 0
        ? persistentProfileValues.find(
          (image) => image.imageId === selectedKasmData.image_id
        )
        : null;

    const maskStyle = {
      display: isPickerShow ? "block" : "none",
    };

    const pickerModalClass = `picker-modal${isPickerShow ? " picker-modal-toggle" : ""
      }`;

    const scrollMenuBar = (offset) => {
      if (!this.menuBarRef.current) {
        return;
      }

      this.menuBarRef.current.scrollTo({
        top: 0,
        left: this.menuBarRef.current.scrollLeft + offset,
        behavior: "smooth"
      });
    };

    const bgImage = () => {
      let launcher_background_url = window.localStorage.getItem("launcher_background_url");
      let bgimage = '/img/backgrounds/background1.jpg'
      if (launcher_background_url && launcher_background_url !== 'undefined') {
        bgimage = launcher_background_url
      }

      return bgimage;
    }

    const showDock = () => {
      if (this.props.usageSummary && this.props.usageSummary.usage_limit) {
        return true
      }
      if (this.props.dockedSessions && this.props.dockedSessions.length > 0) {
        return true
      }
      return false
    }

    return (
      <div className="kasm-outer">
        <Row>
          <div className={'panelbackground' + (this.props.showProfile ? ' showprofile' : '')} style={{ backgroundImage: "url(" + bgImage() + ")" }}>
            <div className="left-section col-lg-12 p-0">
              {this.props.liveKasms && this.props.liveKasms.length > 0 ? this.renderLiveKasms() : ''}
              {this.renderAvailableKasms()}
            </div>

            <div className={'activesessions tw-bg-white/30 dark:tw-bg-slate-900/30 ' + (showDock() ? 'active' : '')}>

              <div ref={this.containerRef} className="session-list">
                {this.props.usageSummary && this.props.usageSummary.usage_limit && (
                  <UsageCounter props={this.props} state={this.state} />
                )}
                {this.renderDockKasms()}
              </div>
              {this.state.modal && (
                <Modal
                  centered={true}
                  isOpen={this.state.modal}
                  className={this.props.className}
                  backdrop={true}
                  toggle={this.toggle}
                >
                  <ModalBody style={{ maxHeight: "215px" }}>
                    <div className="modal-inner">
                      <div className="opera-box">
                        <div className="opera-box-img">
                          {this.state.deleteKasmImage != "" ? (
                            <img
                              onError={this.defaultThumb}
                              className=" "
                              src={this.state.deleteKasmImage}
                            />
                          ) : (
                            <KasmIcon />
                          )}
                        </div>
                        <div className="opera-box-detail">
                          <div className="modal-item">
                            <h4>{this.state.deleteKasmName} </h4>
                            <button onClick={this.toggle}
                              className="tw-bg-black/10 hover:tw-bg-black/20 tw-top-3 tw-right-0 tw-absolute tw-cursor-pointer tw-z-20 lg:tw-right-3 lg:tw-top-3 tw-flex tw-justify-center tw-items-center tw-w-8 tw-h-8 tw-p-2 tw-rounded-full">
                              <svg className="tw-h-4 tw-w-4 dark:tw-fill-white" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 320 512"><path d="M315.3 411.3c-6.253 6.253-16.37 6.253-22.63 0L160 278.6l-132.7 132.7c-6.253 6.253-16.37 6.253-22.63 0c-6.253-6.253-6.253-16.37 0-22.63L137.4 256L4.69 123.3c-6.253-6.253-6.253-16.37 0-22.63c6.253-6.253 16.37-6.253 22.63 0L160 233.4l132.7-132.7c6.253-6.253 16.37-6.253 22.63 0c6.253 6.253 6.253 16.37 0 22.63L182.6 256l132.7 132.7C321.6 394.9 321.6 405.1 315.3 411.3z"></path></svg>
                            </button>
                          </div>
                          <p className="opera-Productivity">
                            <span>Delete the currently running session</span>
                          </p>
                        </div>
                      </div>
                      <div style={{ textAlign: "center" }}>
                        {this.state.deleteClicked ? (
                          <Spinner style={{ width: "64px", height: "64px", margin: "0 auto", marginTop: "17px" }} color={"danger"} />
                        ) : (
                          <button
                            onClick={this.destroyKasms}
                            disabled={this.props.destroyKasmsLoading}
                            className="tw-bg-red-500 hover:tw-bg-red-600 tw-rounded tw-shadow tw-w-full tw-text-white tw-p-3 tw-mt-5"
                            color="danger"
                          >
                            Delete
                          </button>
                        )}
                      </div>
                    </div>
                  </ModalBody>
                </Modal>
              )}
              {this.state.isLaunchModal && (
                <Modal
                  centered={true}
                  className="launch-modal"
                  isOpen={this.state.isLaunchModal}
                  backdrop={true}
                  toggle={this.toggleLaunchModal}
                >
                  <ModalBody>
                    <div className="modal-inner">
                      <div className="opera-box">
                        <div className="opera-box-img">
                          {selectedKasmData.image_src &&
                            selectedKasmData.image_src != "" ? (
                            <img
                              onError={this.defaultThumb}
                              className=" "
                              src={selectedKasmData.image_src}
                            />
                          ) : (
                            <KasmIcon kasm={selectedKasmData} />
                          )}
                        </div>
                        <div className="opera-box-detail">
                          <div className="modal-item">
                            <h4>Launch {selectedKasmData.friendly_name} </h4>
                            <button 
                              onClick={(event) => {
                                this.toggleLaunchModal(event)
                              }}
                              className="tw-bg-black/10 hover:tw-bg-black/20 tw-top-3 tw-right-0 tw-absolute tw-cursor-pointer tw-z-20 lg:tw-right-3 lg:tw-top-3 tw-flex tw-justify-center tw-items-center tw-w-8 tw-h-8 tw-p-2 tw-rounded-full">
                              <svg className="tw-h-4 tw-w-4 dark:tw-fill-white" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 320 512"><path d="M315.3 411.3c-6.253 6.253-16.37 6.253-22.63 0L160 278.6l-132.7 132.7c-6.253 6.253-16.37 6.253-22.63 0c-6.253-6.253-6.253-16.37 0-22.63L137.4 256L4.69 123.3c-6.253-6.253-6.253-16.37 0-22.63c6.253-6.253 16.37-6.253 22.63 0L160 233.4l132.7-132.7c6.253-6.253 16.37-6.253 22.63 0c6.253 6.253 6.253 16.37 0 22.63L182.6 256l132.7 132.7C321.6 394.9 321.6 405.1 315.3 411.3z"></path></svg>
                            </button>
                            
                          </div>
                          <p className="opera-Productivity">
                            <span>{selectedKasmData.description}</span>
                          </p>
                        </div>
                      </div>
                      {selectedKasmData &&
                        selectedKasmData.persistent_profile_settings && selectedKasmData.enabled &&
                        selectedKasmData.persistent_profile_settings.length > 0 ? (
                        <div className="form-group">
                          <span className="label">Persistent Profile</span>
                          <Select
                            id={"persistent_profile_" + selectedKasmData.image_id}
                            key={selectedKasmData.image_id}
                            value={currentImage2 ? currentImage2.value : ""}
                            options={selectedKasmData.persistent_profile_settings.map(
                              (val) => {
                                return { key: val, value: val };
                              }
                            )}
                            valueKey="value"
                            labelKey="key"
                            name="image_id"
                            onChange={this.handlePersistentProfileDropDown.bind(
                              this,
                              selectedKasmData.image_id
                            )}
                          />
                        </div>
                      ) : (
                        ""
                      )}

                      {selectedKasmData &&
                        selectedKasmData.zones && selectedKasmData.enabled &&
                        selectedKasmData.zones.length > 0 && (selectedKasmData.image_type === "Container" ||
                          selectedKasmData.image_type === "Server Pool") ? (
                        <div className="form-group">
                          <span className="label">Deployment Zone</span>
                          <Select
                            id={"zone_" + selectedKasmData.image_id}
                            key={selectedKasmData.image_id}
                            value={
                              this.state.zoneSelections[selectedKasmData.image_id]
                            }
                            options={selectedKasmData.zones.map((val) => {
                              return { key: val.zone_name, value: val.zone_id };
                            })}
                            valueKey="value"
                            labelKey="key"
                            name="image_id"
                            onChange={this.handleZoneDropDown.bind(
                              this,
                              selectedKasmData.image_id
                            )}
                            clearable={false}
                          />
                        </div>
                      ) : (
                        ""
                      )}

                      {selectedKasmData &&
                        selectedKasmData.networks && selectedKasmData.enabled &&
                        selectedKasmData.networks.length > 0 ? (
                        <div className="form-group">
                          <span className="label">Network</span>
                          <Select
                            id={"zone_" + selectedKasmData.image_id}
                            key={selectedKasmData.image_id}
                            value={
                              this.state.networkSelections[selectedKasmData.image_id]
                            }
                            options={selectedKasmData.networks.map((val) => {
                              return { key: val.network_name, value: val.network_id };
                            })}
                            valueKey="value"
                            labelKey="key"
                            name="image_id"
                            onChange={this.handleNetworksDropDown.bind(
                              this,
                              selectedKasmData.image_id
                            )}
                            clearable={false}
                          />
                        </div>
                      ) : (
                        ""
                      )}

                      <div className="form-group">
                        <span className="label">Open Session In:</span>
                        <Select
                          id={"open_session_in_" + selectedKasmData.image_id}
                          key={selectedKasmData.image_id}
                          value={this.state.openTabIn}
                          options={[
                            {
                              value: 'current',
                              key: 'Current Tab'
                            },
                            {
                              value: 'new',
                              key: 'New Tab'
                            },
                            {
                              value: 'window',
                              key: 'New Window'
                            }
                          ]}
                          valueKey="value"
                          labelKey="key"
                          name="image_id"
                          onChange={(e) => {
                            this.setState({ openTabIn: e.value })
                            window.localStorage.setItem('openTabIn', e.value)
                          }
                          }
                        />
                      </div>
                      <Row className="kasmCardFooter">
                        {selectedKasmData.enabled === true ? (
                          <Col md="12">
                            <div>
                              {this.state.createClicked ? (
                                <div>
                                  {" "}
                                  {this.state.currentId ===
                                    selectedKasmData.image_id ? (
                                    <Spinner
                                      color="primary"
                                      style={{ width: "64px", height: "64px", marginTop: "25px", marginBottom: "0px" }}
                                    />
                                  ) : (
                                    <Button
                                      color="primary"
                                      className="btn-block"
                                      style={{ cursor: "pointer" }}
                                      disabled={true}
                                    >
                                      { selectedKasmData.image_type === "Link" ? "Open External Link" : "Launch Session" }
                                      {" "}
                                      <img
                                        src={rightArrow}
                                        alt="rightArrow"
                                        className="ml-3"
                                      />
                                    </Button>
                                  )}
                                </div>
                              ) : (
                                <Button
                                  color="primary"
                                  className="btn-block"
                                  style={{ cursor: "pointer" }}
                                  onClick={selectedKasmData.image_type === "Link" ?() => { this.openLink(selectedKasmData.link_url)} : this.createKasm.bind(
                                    this,
                                    selectedKasmData.image_id,
                                    selectedKasmData.available
                                  )}
                                  disabled={
                                    selectedKasmData.available
                                      ? this.props.createKasmsLoading &&
                                      this.state.currentId ===
                                      selectedKasmData.image_id
                                      : false
                                  }
                                >
                                  {" "}
                                  { selectedKasmData.image_type === "Link" ? "Open External Link" : "Launch Session" }
                                  {" "}
                                  <img
                                    src={rightArrow}
                                    alt="rightArrow"
                                    className="ml-3"
                                  />
                                </Button>
                              )}
                            </div>
                          </Col>
                        ) : (
                          <Col md="12">
                            <div className="disabled-image-message">{ReactHtmlParser(this.props.disabledImageMessage)}</div>
                          </Col>
                        )}
                      </Row>
                    </div>
                  </ModalBody>
                </Modal>
              )}

              <Modal
                centered={true}
                className="launch-modal"
                isOpen={this.state.showResetConfirmationDialog}
                backdrop={true}
                toggle={() => this.setState({ showResetConfirmationDialog: false })}
              >
                <ModalBody>
                  <div className="modal-inner">
                    <div className="opera-box">
                      <div className="opera-box-detail">
                        <div className="modal-item" style={{ marginBottom: "10px" }}>
                          <h4>Confirm</h4>
                          <button onClick={() => this.setState({ showResetConfirmationDialog: false })}
                            className="tw-bg-black/10 hover:tw-bg-black/20 tw-top-3 tw-right-0 tw-absolute tw-cursor-pointer tw-z-20 lg:tw-right-3 lg:tw-top-3 tw-flex tw-justify-center tw-items-center tw-w-8 tw-h-8 tw-p-2 tw-rounded-full">
                            <svg className="tw-h-4 tw-w-4 dark:tw-fill-white" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 320 512"><path d="M315.3 411.3c-6.253 6.253-16.37 6.253-22.63 0L160 278.6l-132.7 132.7c-6.253 6.253-16.37 6.253-22.63 0c-6.253-6.253-6.253-16.37 0-22.63L137.4 256L4.69 123.3c-6.253-6.253-6.253-16.37 0-22.63c6.253-6.253 16.37-6.253 22.63 0L160 233.4l132.7-132.7c6.253-6.253 16.37-6.253 22.63 0c6.253 6.253 6.253 16.37 0 22.63L182.6 256l132.7 132.7C321.6 394.9 321.6 405.1 315.3 411.3z"></path></svg>
                          </button>

                        </div>

                        <div className="opera-Productivity">
                          Are you sure you want to reset the persistent profile?<br />
                          All data for the current profile will be erased. <br />
                          <p>Please type <b>"reset"</b> to confirm.</p>
                        </div>

                        <div className="mobileSearch">
                          <input
                            type="text"
                            className="form-control mr-sm-2"
                            style={{ backgroundImage: "none" }}
                            onChange={(e) => this.verifyResetConfirmation(e.target.value)}
                          />
                        </div>
                      </div>
                    </div>
                  </div>
                </ModalBody>
              </Modal>
            </div>
          </div>
        </Row>
      </div>
    );
  }
}

Listkasms.propTypes = {
  destroyKasms: Proptypes.func.isRequired,
  logout: Proptypes.func.isRequired,
  getUserKasms: Proptypes.func.isRequired,
  createKasms: Proptypes.func.isRequired,
  updateKeepalive: Proptypes.func.isRequired,
  getStatusKasms: Proptypes.func.isRequired,
  destroyKasmsErrorMessage: Proptypes.object,
  liveKasms: Proptypes.array,
  availableKasms: Proptypes.array,
  deleteKasmsError: Proptypes.object,
  errorCreateMessage: Proptypes.string,
  errorCreateMessageDetail: Proptypes.string,
  createKasmsError: Proptypes.string,
  createdKasms: Proptypes.object,
  statusKasms: Proptypes.object,
  getstatuskasmsError: Proptypes.object,
  errorStatusKasmsMessage: Proptypes.object,
  type: Proptypes.string,
  getstatuskasmsLoading: Proptypes.bool,
  destroyKasmsLoading: Proptypes.bool,
  className: Proptypes.object,
  createKasmsLoading: Proptypes.bool,
  history: Proptypes.object.isRequired,
};

Listkasms = withRouter(Listkasms);

export default connect(
  (state) => ({
    dockedSessions: state.dashboard.dockedSessions || [],
    errorCreateMessage: state.dashboard.errorCreateMessage || null,
    errorCreateMessageDetail: state.dashboard.errorCreateMessageDetail || null,
    deleteKasmsError: state.dashboard.deleteKasmsError || null,
    getstatuskasmsLoading: state.dashboard.getstatuskasmsLoading || null,
    destroyKasmsErrorMessage: state.dashboard.destroyKasmsErrorMessage || null,
    createKasmsLoading: state.dashboard.createKasmsLoading || false,
    destroyKasmsLoading: state.dashboard.destroyKasmsLoading || null,
    createKasmsError: state.dashboard.createKasmsError || null,
    statusKasms: state.dashboard.statusKasms || null,
    getstatuskasmsError: state.dashboard.getstatuskasmsError || null,
    errorStatusKasmsMessage: state.dashboard.errorStatusKasmsMessage || null,
    fetchedKasms: state.dashboard.kasms || [],
    createdKasms: state.dashboard.createdKasms || null,
    availableKasms: state.dashboard.availableKasms,
    disabledImageMessage: state.dashboard.disabledImageMessage,
    liveKasms: state.dashboard.liveKasms,
    viewedKasms: state.dashboard.viewedKasms,
    viewKasmsLoading: state.dashboard.viewKasmsLoading,
    usageSummary: state.user.usageSummary,
    searchText: state.dashboard.search || '',
    selectedCategory: state.dashboard.selectedCategory || null,
    showProfile: state.dashboard.showProfile || false,
    login_settings: state.auth.login_settings,
  }),
  (dispatch) => ({
    logout: (logout_data) => dispatch(logout(logout_data)),
    imageFunc: (payload_data) => dispatch(getUserImages(payload_data)),
    destroyKasms: (data) => dispatch(destroyKasms(data)),
    getUserKasms: (data) => dispatch(getUserKasms(data)),
    createKasms: (data) => dispatch(createKasms(data)),
    updateKeepalive: (data) => dispatch(updateKeepalive(data)),
    getStatusKasms: (data) => dispatch(getStatusKasms(data)),
    getViewedKasms: (data) => dispatch(getViewedKasms(data)),
    setDockedSessions: (data) => dispatch(setDockedSessions(data)),
    getDockedSessions: (data) => dispatch(getDockedSessions(data)),
    getUserUsageSummary: (payload_data) => dispatch(getUserUsageSummary()),
    setShowProfile: (data) => dispatch(setShowProfile(data)),
    setProfileSection: (data) => dispatch(setProfileSection(data)),
    setProfileDropdown: (data) => dispatch(setProfileDropdown(data)),
  })
)(Listkasms);
